import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import masterApi from "../api/masterApi";
import { PERFORMANCE_QUERY_KEYS } from "../constants/performanceConstants";

const useGoalCycleOptions = () => {
  const goalCyclesQuery = useQuery({
    queryKey: [PERFORMANCE_QUERY_KEYS.goalCycles, "selector"],
    queryFn: () => masterApi.listGoalCycles({ page: 1, limit: 100 }),
  });

  const goalCycles = useMemo(() => {
    const payload = goalCyclesQuery.data;

    if (Array.isArray(payload?.data)) {
      return payload.data;
    }

    if (Array.isArray(payload?.data?.rows)) {
      return payload.data.rows;
    }

    if (Array.isArray(payload?.rows)) {
      return payload.rows;
    }

    return [];
  }, [goalCyclesQuery.data]);

  const goalCycleOptions = useMemo(
    () =>
      goalCycles.map((cycle) => ({
        value: cycle._id,
        label: cycle.code ? `${cycle.name} (${cycle.code})` : cycle.name,
      })),
    [goalCycles],
  );

  return {
    goalCycles,
    goalCycleOptions,
    isLoading: goalCyclesQuery.isLoading,
    isError: goalCyclesQuery.isError,
    error: goalCyclesQuery.error,
    refetch: goalCyclesQuery.refetch,
  };
};

export default useGoalCycleOptions;
